import React, {useState} from 'react'
import {Sidebar} from 'primereact/sidebar'
import {Dialog} from 'primereact/dialog'
import {renderValue} from "../utils";
import {Button} from "primereact/button";
export type InstructionsProps = {
    details?: any
    dims?: {gridWidth:number, vw:number, vh:number}
}


export const Instructions = ({ details = {}, dims }: InstructionsProps) => {
    const { title = 'Instructions', content = '', hide } = details || {}
    const [visible, setVisible] = useState(false )
    const position = dims.vw < dims.gridWidth + 50 ? 'top-right' : 'left'
    return hide || !content ? ( <></> ) :  (
        <>
        <Sidebar visible={visible} position={"left"}  modal={true} dismissable={true} onHide={() => setVisible(false)}>
            <h1>{title}</h1>
            <div >{renderValue(content, details)}</div>
        </Sidebar>
            <Dialog headerStyle={{display: 'none'}} style={{cursor: 'pointer'}} draggable={false} onClick={() => setVisible(true)} onHide={() => {}} modal={false} visible={!visible} closable={false}
                    position={position}>
                <Button className={"p-button-rounded p-button-outlined p-button-info"} tooltip={'View Instructions'} icon={'pi pi-question'} style={{fontSize: '2em', position: 'relative', top: '15px'}}/>
            </Dialog>
       </>
    )
}